import * as TYPE from "../types";
const initialState = {
  data: [],
  error: null,
};
export const rolesReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case TYPE.ROLES_DATA_FOUND:
      return {
        ...state,
        data: action.payload.data,
      };
    case TYPE.ROLES_DATA_ERROR:
      return {
        ...state,
        error: action.payload || true,
        msg: "OOPS! Something went wrong!",
        data: [],
      };
    case TYPE.NEW_ROLE_ADD_SUCCESS:
      return state;
    case TYPE.NEW_ROLE_ADD_ERROR:
      return {
        ...state,
        error: action.payload || true,
      };
    case TYPE.UPDATE_ROLE_SUCCESS:
      return state;
    case TYPE.UPDATE_ROLE_ERROR:
      return {
        ...state,
        error: action.payload || true,
      };
    default:
      return state;
  }
};
